export type KeyboardLayout = 'AZERTY' | 'QWERTY';

export const KEYBOARD_LAYOUTS: Record<KeyboardLayout, string[][]> = {
  AZERTY: [
    ['A', 'Z', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['Q', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M'],
    ['ENTER', 'W', 'X', 'C', 'V', 'B', 'N', 'BACKSPACE'],
  ],
  QWERTY: [
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M'],
    ['ENTER', 'Z', 'X', 'C', 'V', 'B', 'N', 'BACKSPACE'],
  ],
};

export const AZERTY_TO_QWERTY: Record<string, string> = {
    A: 'Q',
    Z: 'W',
    Q: 'A',
    W: 'Z',
    M: 'M',
  };